import { render, staticRenderFns } from "./AccessView.vue?vue&type=template&id=66250954&scoped=true"
import script from "./AccessView.vue?vue&type=script&lang=js"
export * from "./AccessView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66250954",
  null
  
)

export default component.exports